import {
  Target,
  Flame,
  Clipboard,
  Crown,
  Star,
  Trophy,
  Dumbbell,
  Activity,
  Apple,
  Pill,
  Heart,
  Move,
  Thermometer,
  BarChart3
} from 'lucide-react';

const ICON_MAP: Record<string, React.ComponentType<{ className?: string }>> = {
  TARGET: Target,
  FLAME: Flame,
  CLIPBOARD: Clipboard,
  CROWN: Crown,
  STAR: Star,
  TROPHY: Trophy,
  DUMBBELL: Dumbbell,
  RUNNING: Activity,
  APPLE: Apple,
  PILL: Pill,
  HEART: Heart,
  MOVE: Move,
  THERMOMETER: Thermometer,
  CHART: BarChart3,
};

interface BadgeIconProps {
  iconName: string;
  className?: string;
}

export default function BadgeIcon({ iconName, className = "w-12 h-12" }: BadgeIconProps) {
  const IconComponent = ICON_MAP[iconName] || Trophy;
  
  return <IconComponent className={className} />;
}
